export class BankMoviment {
    id: number;
    account: any;
    bankConciliation: any;
    bondPay: any;
    operation: any;
    historic: any;
    dated: string;
    value: number;
    compensated: boolean;
    z;
}

export class BankMovimentReturn {
    id: number;
    sourceAccountId: any;
    sourceAccountName: any;
    destinationAccountId: any;
    destinationAccountName: any;
    historic: any;
    dated: string;
    value: number;
    operation: any;
    companyAccountPlanId: any;
    accountPlanName: any;
    compensated: boolean;
}

export class BankMovimentOperation {
    sourceAccountId: number;
    destinationAccountId: any;
    value: any;
    historic: any;
    dated: string;
    operation: string;
    companyAccountPlanId: any;
    companyAccountPlanDestinationId: any;
    compensated: boolean;
}
